import { observable, set } from 'mobx';
import {
    IAutomationStepAction,
    IAutomationStepActionBase,
    TAutomationActionServerType,
    TAutomationBlockAction,
    TAutomationStepBlockErrorMessageKeys
} from '../../../types/automation.types';
import type { RootStore } from '~/stores/root.store';
import { prepClassForServer } from '../../../utils/data.utils';
import { AutomationActionType } from '../../../components/Automations/AutomationsEnums';
import { IAutomationSidebarConfig } from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/automation-sidebar.types';
import { IFlowsBetaUserType } from '~/models/user.model';

export abstract class AutomationStepActionBase
    implements IAutomationStepActionBase
{
    @observable _id: string;
    @observable type: AutomationActionType;
    @observable _type: TAutomationActionServerType;
    @observable completed: boolean;
    @observable completed_at: string;
    @observable declined_at: string;
    @observable description: string;
    rootStore: RootStore;

    constructor(
        automationStepAction: IAutomationStepAction,
        rootStore: RootStore
    ) {
        set(this, automationStepAction);
        this.rootStore = rootStore;
    }

    abstract get title(): string;

    abstract get isValid(): boolean;

    abstract get errorMessageKey(): TAutomationStepBlockErrorMessageKeys;

    abstract getSideBarConfig(
        userType?: IFlowsBetaUserType,
        folderName?: string
    ): IAutomationSidebarConfig;

    abstract get AutomationBlockAction(): TAutomationBlockAction;

    getDataForServer(): IAutomationStepActionBase {
        return prepClassForServer(this);
    }
}
